var app = angular.module("leonardo");

var ReportsActivityListFilters = function(
  $scope,
  $rootScope,
  $state,
  $timeout,
  ReportService,
  $controller,
  AccountUserService,
  FilterService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersActivity;

  $scope.group_options.push({ id: 'user_role', name: 'User Role' });
  $scope.group_options.push({id: 'managed_by', name: 'Managed By'});

  $scope.filters_options = [];

  $scope.initOptions = function() {
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'account_user',
        name: 'User(s)',
        label: 'User(s)',
        inline: false,
        type: 'options',
        multiple: true,
        modeUser: true,
        placeholder: 'All Users',
        condition: true,
        service: AccountUserService,
        conflicts: []
      },
      {
        id: 'report_to',
        name: 'Report To',
        label: 'Report To',
        inline: false,
        type: 'options',
        multiple: true,
        modeUser: true,
        placeholder: 'All Users',
        condition: true,
        service: AccountUserService,
        conflicts: []
      },
      {
        id: 'role',
        name: 'User Roles',
        label: 'User Roles',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Roles',
        condition: true,
        options: $scope.authDataService.getRolesValid(),
        conflicts: []
      },
      {
        id: 'active',
        name: 'User Status',
        label: 'User Status',
        inline: false,
        type: 'options',
        multiple: false,
        placeholder: 'All User Status',
        condition: true,
        options: AccountUserService.STATUS_OPTIONS,
        conflicts: []
      },
      {
        id: 'mia',
        name: 'M.I.A.',
        label: 'Notes Important',
        help: 'Missing In Action: Users with a period of inactivity of 5+ days during the selected date range.',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'fields_active',
        name: 'Fields To Show',
        label: 'Fields To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.fieldsReportActivity,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  if ($scope.filters_name !== 'filters_report') {
    var filters = $scope.filterService.hasFilter($scope.filters_name) ? $scope.filterService.getFilter($scope.filters_name) : [];

    if (!angular.isArray(filters)) {
      filters = filters.split(',');
    }

    angular.forEach($scope.filterService.filters, function(value, key) {
      if (!_.contains(filters, key) && $scope.isValid(key)) {
        filters.push(key);
      }
    });

    if (!$scope.filterService.hasFilter('active') && isNull(ReportService.getQuickReport())) {
      $scope.filterService.setFilter('active', 1, true);

      if (!_.contains(filters,'active')) {
        filters.push('active');
      }
    }

    if (!$scope.filterService.hasFilter('property_reports') && !ReportService.quick_report) {
      if (!_.contains(filters,'property_reports')) {
        filters.push('property_reports');
      }
    }

    if (!$scope.filterService.hasFilter('role') && !ReportService.quick_report) {
      if (!_.contains(filters,'role')) {
        filters.push('role');
      }
    }

    if ($state.$current.includes['administrative-reports']){
      $scope.filterService.setFilter('group_by', 'ungroup', true);
    }

    $scope.filterService.setFilter($scope.filters_name, filters, true);
    $rootScope.$broadcast('filters-report:initialized');
  }

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_ACTIVITY);
  }, 100);

};

app.controller('ReportsActivityListFilters', [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  'ReportService',
  '$controller',
  'AccountUserService',
  'FilterService',
  ReportsActivityListFilters
]);
